import React, { useEffect } from "react";
import { useLocation } from "react-router";
import sysend from "sysend";
import { isIOS } from "../../Utils";

export default function IamsmartAnonFormFilling() {
    const query = useLocation().search;
    useEffect(() => {
        if (isIOS()) {
            // if (localStorage) {
            //     localStorage.setItem("IamsmartAnonFormFilling", query);
            // }
            const channel = new BroadcastChannel("IamsmartAnonFormFilling_channel");
            channel.postMessage({"query":query});
            window.close();    
        } else {
            sysend.broadcast("IamsmartAnonFormFilling", query);
        }

        window.close();
    }, []);
    return <>IamsmartAnonFormFilling</>;
}
